import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ess_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function fmtDuration(secs) {
  secs = Math.max(0, Math.floor(secs || 0));
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

//export function fmtTime(iso) {
//  if (!iso) return "";
// const d = new Date(iso);
//  return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
//}

/**
 * Format an ISO timestamp to local time string (e.g., "12:06 AM")
 */
export function fmtTime(isoString) {
  if (!isoString) return "";
  
  const date = new Date(isoString);
  
  // Check if date is valid
  if (isNaN(date.getTime())) return "";
  
  // Format in local timezone
  return date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });
}
export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function startOfWeekISO(d = new Date()) {
  const day = d.getDay();
  const diff = (day + 6) % 7; // monday start
  const m = new Date(d);
  m.setDate(d.getDate() - diff);
  return m.toISOString().slice(0, 10);
}

export function fyBounds(d = new Date()) {
  const y = d.getFullYear();
  const m = d.getMonth() + 1;
  const startY = m >= 4 ? y : y - 1;
  return { start: `${startY}-04-01`, end: `${startY + 1}-03-31` };
}

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (!detail) return e.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return JSON.stringify(detail);
}
